import { Button, EButtonColorVariant, ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React, { useEffect } from 'react';

import { trackPromoBannerClicked, trackPromoBannerViewed } from '@/services/analytics/promo';

type TAdvertisementTileV3Props = {
  title: string;
  heading: string;
  promoText: string;
  linkLabel: string;
  image: string;
  href: string;
  target?: string;
  gradient?: boolean;
  showBanner: boolean;
};

export const AdvertisementTileV3 = ({
  title,
  heading,
  promoText,
  linkLabel,
  image,
  target,
  gradient,
  href,
  showBanner,
}: TAdvertisementTileV3Props) => {
  const handleCLick = () => {
    trackPromoBannerClicked({
      bannerText: heading,
      bannerCTA: linkLabel,
      bannerLink: href,
      bannerName: title,
      source: 'search',
      odn_id: null,
    });
  };

  useEffect(() => {
    trackPromoBannerViewed({
      bannerText: heading,
      bannerCTA: linkLabel,
      bannerLink: href,
      bannerName: title,
      source: 'search',
      odn_id: null,
    });
  }, [heading, href, linkLabel, promoText, title]);

  if (!showBanner) return null;

  return (
    <li className="relative overflow-hidden">
      <div>
        <Image
          className="rounded-2xl"
          src={image}
          alt="Outdoorsy Stays advertisement image"
          role="presentation"
          layout="fill"
          objectFit="cover"
          width={0}
          height={0}
          style={{ width: '100%', height: '100%' }}
        />
        {gradient && (
          <div className="absolute inset-0 bg-gradient-to-b from-[#0000007b] to-transparent rounded-2xl" />
        )}
      </div>
      <div className="flex flex-col items-center justify-between h-full p-6 text-center text-white gap-y-2 min-h-[19rem] md:min-h-auto">
        {promoText && (
          <div className="absolute z-10 pt-1 pb-1 -left-18 -rotate-45 bg-[#FF9467] w-52">
            {promoText && <Text variant={ETextStyleVariant.MediumBold}>{promoText}</Text>}
          </div>
        )}
        <div className="z-10">
          {title && (
            <Text variant={ETextStyleVariant.LargeBold} className="pt-5">
              {title}
            </Text>
          )}
          <div className="pt-2">
            {heading && <Text variant={ETextStyleVariant.MediumRegular}>{heading}</Text>}
          </div>
        </div>
        <Button
          onClick={handleCLick}
          label={linkLabel}
          variant={EButtonColorVariant.Tertiary}
          href={href}
          target={target}
        />
      </div>
    </li>
  );
};
